
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";

export default defineComponent({
  name: "PackageForYou",
  components: {
    Header,
  },
  data() {
    return {
      passwordDialog: false,
      paymentFillPassword: true,
      paymentData: {
        value: 29000,
        creditCardForShowing: "4443",
        creditType: "visa",
      },
      pincode: {
        pincode1: "",
        pincode2: "",
        pincode3: "",
        pincode4: "",
        pincode5: "",
        pincode6: "",
      },
      pincodeValidate: false,
    };
  },
  methods: {
    numberWithCommas(number: number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    closeModalConfirm() {
      this.passwordDialog = false;
      this.pincodeValidate = false;
      this.pincode.pincode1 = "";
      this.pincode.pincode2 = "";
      this.pincode.pincode3 = "";
      this.pincode.pincode4 = "";
      this.pincode.pincode5 = "";
      this.pincode.pincode6 = "";
    },
    confirmPassword() {
      let noData = false;
      for (const [key, value] of Object.entries(this.pincode)) {
        if (!value && value != "0") {
          noData = true;
        }
      }
      this.pincodeValidate = true;
      if (!noData) {
        this.pincodeValidate = false;
        this.paymentFillPassword = false;
        this.passwordDialog = false;
      }
    },
    checkedOTPOne(e: any) {
      if (e.target.value.length) {
        const input = this.$refs["pincode_2"] as any;
        input.select();
      }
    },
    checkedOTPTwo() {
      const two = this.pincode.pincode2 + "";
      if (!two.length) {
        this.pincode.pincode2 = "";
        const input = this.$refs["pincode_1"] as any;
        input.select();
      } else {
        const input = this.$refs["pincode_3"] as any;
        input.select();
      }
    },
    checkedOTPThree() {
      const three = this.pincode.pincode3 + "";
      if (!three.length) {
        this.pincode.pincode3 = "";
        const input = this.$refs["pincode_2"] as any;
        input.select();
      } else {
        const input = this.$refs["pincode_4"] as any;
        input.select();
      }
    },
    checkedOTPFour() {
      const four = this.pincode.pincode4 + "";
      if (!four.length) {
        this.pincode.pincode4 = "";
        const input = this.$refs["pincode_3"] as any;
        input.select();
      } else {
        const input = this.$refs["pincode_5"] as any;
        input.select();
      }
    },
    checkedOTPFive() {
      const five = this.pincode.pincode5 + "";
      if (!five.length) {
        this.pincode.pincode5 = "";
        const input = this.$refs["pincode_4"] as any;
        input.select();
      } else {
        const input = this.$refs["pincode_6"] as any;
        input.select();
      }
    },
    checkedOTPSix() {
      const six = this.pincode.pincode6 + "";
      if (!six.length) {
        this.pincode.pincode6 = "";
        const input = this.$refs["pincode_5"] as any;
        input.select();
      } else if (six.length > 1) {
        this.pincode.pincode6 = six.slice(1, 2);
      }
    },
  },
});
